const entity = {
  name: {
    singular: 'Página',
    plural: 'Páginas'
  },
  styles: {
    gridTemplateColumns: '30% 1fr',
    gridTemplateAreas: '"main secondary"'
  },
  collection: 'pages',
  tableHeaders: [
    { text: 'Título', value: 'title', type: 'string' },
    { text: 'Url Amigável', value: 'url', type: 'string' },
    { text: 'Criado em ', value: 'createdAt', type: 'date' },
    { text: 'Atualizado em', value: 'updatedAt', type: 'date' },
    { text: 'Entrada ', value: 'dateIn', type: 'date' },
    { text: 'Saída', value: 'dateOut', type: 'date' },
    { text: 'Publicado', value: 'published', type: 'boolean' },
    { text: 'Actions', value: 'action', sortable: false }
  ],
  model: {
    featuredImage: {
      path: '',
      size: 0,
      uploaded: false,
      url: ''
    },
    featuredImageMobile: {
      path: '',
      size: 0,
      uploaded: false,
      url: ''
    },
    title: '',
    body: '',
    summary: '',
    url: '',
    published: false,
    dateIn: '',
    dateOut: ''
  },
  config: {
    name: 'Config',
    hasPreview: true,
    fields: [
      {
        type: 'text-field',
        label: 'Título',
        model: 'title',
        required: true
      },
      {
        type: 'text-field',
        label: 'Resumo',
        model: 'summary',
        required: false
      },
      {
        type: 'url',
        label: 'Url amigável',
        model: 'slug',
        required: true
      },
      {
        type: 'date-picker',
        label: 'Data de Entrada',
        hint: 'Deixe em branco caso não tenha data limite.',
        model: 'dateIn',
        required: false,
        size: 'xs12 sm12 md6 lg6'
      },
      {
        type: 'date-picker',
        label: 'Data de Saída',
        hint: 'Deixe em branco caso não tenha data limite.',
        model: 'dateOut',
        required: false,
        size: 'xs12 sm12 md6 lg6'
      },
      {
        type: 'switch',
        model: 'published',
        label: 'Publicado'
      }
    ]
  },
  schema: {
    groups: [
      {
        name: 'Conteúdo',
        fields: [
          {
            type: 'code-editor',
            label: 'Conteúdo',
            model: 'body',
            required: false,
            language: 'xml'
          }
        ]
      },
      {
        name: 'Imagens',
        fields: [
          {
            type: 'single-file',
            label: 'Imagem principal - Desktop',
            model: 'featuredImage',
            hideInput: true,
            size: 'xs12 sm12 md6 lg6'
          },
          {
            type: 'single-file',
            label: 'Mobile',
            model: 'featuredImageMobile',
            hideInput: true,
            size: 'xs12 sm12 md6 lg6'
          }
        ]
      },
      {
        name: 'Estilos',
        fields: [
          {
            type: 'code-editor',
            language: 'css',
            label: 'Estilos',
            model: 'styles',
            required: false
          }
        ]
      }
    ]
  },
  formOptions: {
    validateAfterLoad: true,
    validateAfterChanged: true,
    validateAsync: true
  }
}

export default [
  {
    path: '/pages',
    meta: {
      entity,
      requiresAuth: true,
      requiresPermissionTo: 'pages',
      crud: 'list'
    },
    component: () => import(/* webpackChunkName: 'banners' */ '../../../views/Crud.vue')
  }, {
    path: '/pages/new',
    meta: {
      entity,
      requiresAuth: true,
      requiresPermissionTo: 'pages',
      crud: 'form'
    },
    component: () => import(/* webpackChunkName: 'banners' */ '../../../views/Crud.vue')
  }, {
    path: '/pages/:id',
    meta: {
      entity,
      requiresAuth: true,
      requiresPermissionTo: 'pages',
      crud: 'form'
    },
    component: () => import(/* webpackChunkName: 'banners' */ '../../../views/Crud.vue')
  }
]
